import { useEffect, useState } from "react";
import CustomInput from "../../../Component/BasicComponents/CustomInput";
import RouteDropdown from "../../../Component/BasicComponents/Dropdowns/RouteDropdown";
import {
  
  useGetEmployeeStatus,
  useGetGradeMastersData,
} from "../../Employee/hooks/useEmployee";
import { useGetOrgUnitsData } from "../../Configuration/Grade Master/hooks/useGradeMaster";
import { useAddAnnouncement, useAnnouncementByID, useUpdateAnnouncement } from "../hooks/useAnnouncement";
import { Spinner } from "reactstrap";
import { handleMedia } from "../../edetailing/repository/EdetailingRepository";
import PaginatedRouteDropdown from "../../../Component/BasicComponents/Dropdowns/PaginatedDropdownWrapper";
import { getEmployeeFilterList } from "../../POB/hooks/POBRepository";
import { showToast } from "../../../utils/toastUtils";

interface Props {
  mode: "add" | "edit";
  selectedRow?: any;
  setIsModalOpen: any;
}

function AnnouncementModal({ mode, selectedRow, setIsModalOpen }: Props) {
  const [isFormReady,setIsFormReady]=useState(false)
  const [announcementMessage, setAnnouncementMessage] = useState("");
  const [announcementTitle, setAnnouncementTitle] = useState("");
  const [announcementStartDate, setAnnouncementStartDate] = useState("");
  const [announcementEndDate, setAnnouncementEndDate] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [orgUnit, setOrgUnit] = useState<any[]>([]);
  const [grade, setGrade] = useState<any[]>([]);
  const [employee, setEmployee] = useState<any[]>([]);
  const [status,setStatus]=useState('')
  const [announcementUrl, setAnnouncementUrl] = useState("");
  const [isImageModalOpen, setIsImageModalOpen] = useState(false);

  const [media, setMedia] = useState("");
  const BASE_URL = "https://tspc-development.truesales.in/media?id=";

  const { data: gradeMaster } = useGetGradeMastersData({ enable: true });
  const { data: orgUnitList } = useGetOrgUnitsData({ enable: true });
  const {data:employeeStatus}=useGetEmployeeStatus({enable:true})

  const { data: announcementById } = useAnnouncementByID({
    enabled: mode === "edit",
    id: selectedRow?.AnnouncementId,
  });

  // Populate fields in edit mode
  useEffect(() => {
    if (mode === "edit" && announcementById?.data) {
      setAnnouncementMessage(announcementById.data.AnnouncementMessage || "");
      setAnnouncementTitle(announcementById.data.AnnouncementTitle || "");
      setAnnouncementStartDate(announcementById.data.AnnouncementStdate || "");
      setAnnouncementEndDate(announcementById.data.AnnouncementEdate || "");
      setOrgUnit(
        announcementById?.data?.OrgUnits.map((item: any) =>
          String(item.Orgunitid)
        ) || []
      );
      setGrade(
        announcementById?.data?.Grades.map((item: any) =>
          String(item.GradeId)
        ) || []
      );
    setEmployee(
      announcementById?.data?.Employees?.map((emp: any) => ({
        id: String(emp.EmployeeId),
        label: `${emp.FirstName} ${emp.LastName}`.trim()
      })) || []
    );
      setStatus(announcementById?.data.AnnouncementStatus)
      
      setAnnouncementUrl(announcementById.data.AnnouncementsUrl || "");
      setMedia(
  announcementById?.data?.MediaIds
    ? announcementById.data.MediaIds.split(",")
    : []
);
setIsFormReady(true);
    

  } else if (mode === "add") {
    // for add mode, form is ready when dropdown data is loaded
    if (orgUnitList?.data && gradeMaster?.data) {
      setIsFormReady(true);
    }
  }
  }, [mode, announcementById,gradeMaster,orgUnitList]);

  const formattedOrgUnits = Object.entries(orgUnitList?.data || {}).map(
    ([key, value]: any) => ({
      id: key,
      label: value,
    })
  );

  const formattedEmployeeStatus=Object.keys(employeeStatus?.data?.EmpStatus||{}).map((item:any)=>{
    return(
    {
      id:employeeStatus?.data?.EmpStatus[item],
      label:employeeStatus?.data?.EmpStatus[item]
    }
  )
})

const formateGrade=gradeMaster?.data?.slice(1)
console.log('formate',formateGrade)


  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      try {
        const mediaId = await handleMedia(file);
        console.log("mediaiii", mediaId);

        setMedia(mediaId);
        console.log("Uploaded Media ID:", mediaId);
      } catch (error) {
        console.error("Media upload failed:", error);
      }
    }
  };
const { mutate: addAnnouncement, isPending: isAdding } = useAddAnnouncement();
const { mutate: updateAnnouncement, isPending: isUpdating } = useUpdateAnnouncement();

const handleSubmit = (e: React.FormEvent) => {
  e.preventDefault();

  // ✅ Validation checks
  if (!announcementTitle?.trim()) {
    showToast.warning("Announcement title is required");
    return;
  }
  if (!announcementMessage?.trim()) {
    showToast.warning("Announcement message is required");
    return;
  }
  if (!announcementStartDate) {
    showToast.warning("Start date is required");
    return;
  }
  if (!announcementEndDate) {
    showToast.warning("End date is required");
    return;
  }
  if (!orgUnit || orgUnit.length === 0) {
    showToast.warning("Please select at least one Org Unit");
    return;
  }
  if (!grade || grade.length === 0) {
    showToast.warning("Please select at least one Grade");
    return;
  }


  // ✅ Payload
  const payload = {
    AnnouncementMessage: announcementMessage,
    AnnouncementTitle: announcementTitle,
    AnnouncementStdate: announcementStartDate,
    AnnouncementEdate: announcementEndDate,
    OrgUnits: orgUnit,
    Grades: grade,
    EmployeeIds: employee.map((item) => item.id),
    AnnouncementsUrl: announcementUrl,
    MediaIds: Array.isArray(media) ? media : [media], // Ensure it's an array
    AnnouncementStatus: status,
  };

  setIsSubmitting(true)
  // ✅ API call only if valid
  if (mode === "edit") {
    updateAnnouncement({
      id: selectedRow?.AnnouncementId, // ID required for update
      body: payload,
    },
   {
        onSuccess: () => {
          setIsModalOpen(false); // ✅ close only on success
        },
        onSettled: () => setIsSubmitting(false), // ✅ reset always
      }
    );
  } else {
    addAnnouncement(payload,{
      onSuccess: () => {
     
        setIsModalOpen(false); // ✅ close only on success
      },
      onSettled: () => setIsSubmitting(false), // ✅ reset always
    });
  }

  setIsModalOpen(false);
};




const isLoading =
  !orgUnitList?.data ||
  !gradeMaster?.data ||
  (mode === "edit" && !announcementById?.data);
  return (
    <>
      {!isFormReady ? (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "60vh" }}
        >
          <Spinner color="primary" style={{ width: "3rem", height: "3rem" }} />
          {/* <span className="ms-3">Loading SGPI Brands...</span> */}
        </div>
      ) : (
        <div>
          <div className="row">
            <div className="col-md-6">
              <CustomInput
                label="Announcement Message*"
                type="textarea"
                value={announcementMessage}
                style={{
                  backgroundColor: "transparent",
                  border: "0.2px solid #d4d4d4",
                }}
                onChange={(e) => setAnnouncementMessage(e.target.value)}
              />
            </div>
            <div className="col-md-6">
              <CustomInput
                label="Announcement Title*"
                type="text"
                value={announcementTitle}
                style={{
                  backgroundColor: "transparent",
                  border: "0.2px solid #d4d4d4",
                }}
                onChange={(e) => setAnnouncementTitle(e.target.value)}
              />
            </div>

            <div className="col-md-6">
              <CustomInput
                label="Announcement Start Date*"
                type="date"
                min={new Date().toISOString().split("T")[0]}
                value={announcementStartDate}
                style={{
                  backgroundColor: "transparent",
                  border: "0.2px solid #d4d4d4",
                }}
                onChange={(e) => setAnnouncementStartDate(e.target.value)}
              />
            </div>

            <div className="col-md-6">
              <CustomInput
                label="Announcement End Date*"
                type="date"
                min={new Date().toISOString().split("T")[0]}
                value={announcementEndDate}
                style={{
                  backgroundColor: "transparent",
                  border: "0.2px solid #d4d4d4",
                }}
                onChange={(e) => setAnnouncementEndDate(e.target.value)}
              />
            </div>

            <div className="col-md-6">
              <CustomInput
                label="Announcement URL"
                type="text"
                value={announcementUrl}
                style={{
                  backgroundColor: "transparent",
                  border: "0.2px solid #d4d4d4",
                }}
                onChange={(e) => setAnnouncementUrl(e.target.value)}
              />
            </div>
            <div className="col-md-6">
              <RouteDropdown
                options={formateGrade || []}
                isMulti
                DropdownHeading="Grade*"
                onChange={(e: any) => setGrade(e)}
                value={grade}
              />
            </div>

            <div className="col-md-6">
              <RouteDropdown
                options={formattedOrgUnits}
                isMulti
                DropdownHeading="Org Unit*"
                onChange={(e: any) => setOrgUnit(e)}
                value={orgUnit}
              />
            </div>
            <div className="col-md-6">
             <PaginatedRouteDropdown
              DropdownHeading="Employee"
            placeholder="Select Employee"
            isMulti={true}
                    fetchOptions={async (page: any, search: any) => {
                           const res = await getEmployeeFilterList({
                             page,
                             limit: 10,
                             search: search || "",
                           });
                           return Object.keys(res?.data || {}).map((key) => ({
                             id: key,
                             label: res?.data[key],
                           }));
                         }}
             onChange={(val:any) => setEmployee(val)}
             initialSelectedOptions={employee}
             />
            </div>
              <div className="col-md-6">
              <RouteDropdown
                options={formattedEmployeeStatus}
                DropdownHeading="Status*"
                onChange={(e: any) => setStatus(e)}
                value={status}
              />
            </div>

            <div className="col-md-3 mt-2">
              <label style={{ fontWeight: "500" }}>Media</label>
              <input
                type="file"
                className="form-control"
                accept="image/*"
                onChange={handleFileChange}
                style={{
                  border: "2px solid #EDEDED",
                  borderRadius: "8px",
                  padding: "13px",
                  fontSize: "14px",
                  width: "100%",
                }}
              />
            </div>


            {media && (
              <div className="row mb-3">
                <div className="col-md-6" style={{ marginBottom: "10px" }}>
                  <label style={{ fontWeight: "500", display: "block" }}>
                    Uploaded Media
                  </label>
                  <img
                    src={`${BASE_URL}${media}`}
                    alt="Uploaded Media"
                    style={{
                      width: "100px",
                      height: "100px",
                      borderRadius: "8px",
                      marginTop: "8px",
                      cursor: "pointer",
                    }}
                    onClick={() => setIsImageModalOpen(true)}
                  />
                </div>
              </div>
            )}

            {isImageModalOpen && (
              <div
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "100vw",
                  height: "100vh",
                  background: "rgba(0, 0, 0, 0.7)",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  zIndex: 1050,
                }}
                onClick={() => setIsImageModalOpen(false)} // Close when background clicked
              >
                <img
                  src={`${BASE_URL}${media}`}
                  alt="Preview"
                  style={{
                    maxWidth: "90%",
                    maxHeight: "90%",
                    borderRadius: "10px",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.5)",
                  }}
                />
              </div>
            )}
          </div>

          <div style={{ marginTop: "20px" }}>
            <button
    onClick={handleSubmit}
    className="btn btn-primary"
    disabled={isSubmitting || isAdding || isUpdating} // ✅ prevent multiple clicks
  >
    {isSubmitting ? "Processing..." : mode === "add" ? "Submit" : "Update"}
  </button>
  <button
    onClick={() => setIsModalOpen(false)}
    className="btn btn-light"
    style={{ color: "gray", marginLeft: "10px" }}
    disabled={isSubmitting}
  >
    Cancel
  </button>

          </div>
        </div>
      )}
    </>
  );
}

export default AnnouncementModal;
